import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import TopIllo from '../vaccine/topIllo'
import Byline from './byline'
import NavTop from './navtop'
import {
  pubdateString,
  convertDatesToAP,
  formatTimestamp,
} from './component-helpers/datehelpers'
import topperStyles from '../../styles/modules/topper.module.less'
import PageNav from '../vaccine/pagenav'
import navLinkData from '../../data/nav.sheet.json'
import BigNumber from '../vaccine/bignumbers'
import { dataLabels } from '../vaccine/vaccine-component-helpers/dataLabels'

//remove instructions. Note: It's important instructions stay in the sheet otherwise the import will fail
navLinkData.shift()

const sources = {
  CDC: 'Centers for Disease Control and Prevention',
  'TX DHHS': 'Texas Department of Health and Human Services',
  CDPH: 'California Department of Public Health',
}

const Topper = ({ meta, MARKET_STATE, updateLine }) => {
  const {
    EMBEDDED,
    PROJECT: {
      AUTHORS,
      ISO_MODDATE,
      ISO_PUBDATE,
      DISPLAY_TITLE,
      modDateString,
    },
  } = meta

  let newModdateString = modDateString ? modDateString : ''
  if (newModdateString) {
    newModdateString = convertDatesToAP(newModdateString)
  }

  return (
    <Fragment>
      {!EMBEDDED && <NavTop meta={meta} />}
      {navLinkData.length > 0 && <PageNav links={navLinkData} />}
      <header className={topperStyles.header}>
        <TopIllo />
        <section
          aria-label="Topper headline, deck, byline and dateline"
          className={topperStyles.textContainer}
        >
          <h1 className={topperStyles.hed}>{DISPLAY_TITLE}</h1>

          <div className={topperStyles.dateby}>
            <span>By</span>
            {AUTHORS.length > 0 && (
              <Fragment>
                {AUTHORS.map((author, index) => {
                  // Pass special flag if this is the last item
                  let isLast = false
                  if (index === AUTHORS.length - 1) {
                    isLast = true
                  }
                  // Add the bylines
                  return (
                    <Byline
                      key={index}
                      name={author}
                      index={index}
                      isLast={isLast}
                    />
                  )
                })}
              </Fragment>
            )}
            <br />
          </div>
          <div className={topperStyles.alertBox}>
            {updateLine ? (
              <div dangerouslySetInnerHTML={{ __html: updateLine }}></div>
            ) : (
              <p>
                We stopped updating this page on October 25, 2021. For
                up-to-date information on vaccinations in {MARKET_STATE}, we
                recommend the Centers for Disease Control and Prevention's{' '}
                <a href="https://covid.cdc.gov/covid-data-tracker/#vaccinations_vacc-people-onedose-percent-pop12">
                  COVID Data Tracker.
                </a>
              </p>
            )}
          </div>
        </section>
      </header>
    </Fragment>
  )
}

Topper.propTypes = {
  meta: PropTypes.object.isRequired,
}

export default React.memo(Topper)
